// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1vmIV","title":"Info_title__2GcuB","links":"Info_links__2W-fM","link":"Info_link__2oi5E","logo":"Info_logo__1FlhZ"};